import SvgIcon from "@/components/SvgIcon";
import Vue from "vue";

Vue.component("SvgIcon", SvgIcon);

export const requireAll = (requireContext) =>
  requireContext.keys().map(requireContext);
